import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { Mail, Settings, Layout } from 'lucide-react';
import EmailBuilder from '../../components/email/EmailBuilder';
import AutomationBuilder from '../../components/email/AutomationBuilder';
import EmailAnalytics from '../../components/email/EmailAnalytics';
import EmailProviderSettings from '../../components/email/EmailProviderSettings';

const EmailMarketing: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'campaigns' | 'automations' | 'templates' | 'settings'>('campaigns');
  const navigate = useNavigate();

  const handleTabChange = (tab: typeof activeTab) => {
    setActiveTab(tab);
    navigate(`/dashboard/email-marketing/${tab === 'campaigns' ? '' : tab}`);
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Email Marketing</h1>
        <p className="mt-2 text-sm text-gray-600">
          Create and manage your email campaigns and automations
        </p>
      </div>

      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => handleTabChange('campaigns')}
              className={`${
                activeTab === 'campaigns'
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`}
            >
              <Mail className="h-5 w-5 mr-2" />
              Campaigns
            </button>
            <button
              onClick={() => handleTabChange('automations')}
              className={`${
                activeTab === 'automations'
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`}
            >
              <Layout className="h-5 w-5 mr-2" />
              Automations
            </button>
            <button
              onClick={() => handleTabChange('settings')}
              className={`${
                activeTab === 'settings'
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`}
            >
              <Settings className="h-5 w-5 mr-2" />
              Provider Settings
            </button>
          </nav>
        </div>
      </div>

      <Routes>
        <Route index element={<EmailBuilder />} />
        <Route path="automations" element={<AutomationBuilder />} />
        <Route path="settings" element={<EmailProviderSettings />} />
      </Routes>
    </div>
  );
};

export default EmailMarketing;